module.exports = __webpack_public_path__ + "img/chip-purple.9ba32134.png";